<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('描述信息')" prop="operateDescription">
                <a-textarea v-model="model.operateDescription" :placeholder="$t('请输入描述信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {frozenBatch} from '@/api/api'
  export default {
    name: 'AccountExceptionListModal',
    components: {
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          queryById: "/sys/userExpectionRecord/edit",
        },
      }
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      validatorRules() {
        return {
          operateDescription: {required: true,message:this.$t('请输入描述信息'),trigger: 'blur'}
        }
      },
    },
    methods: {
      init(id,status) {
        let that = this;
        this.title = this.$t('操作');
        this.visible = true;
        this.model = {
          id: id
        };
        this.status = status;
      },
      close() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk(){
        this.$refs.form.validate(valid => {
          if(valid){
            frozenBatch({id: this.model.id, status: this.status,operateDescription: this.model.operateDescription}).then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.close();
              } else {
                this.$message.warning(res.message);
              }
            });
          }
        })
      }
    }
  }
</script>
<style scoped>
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>